export enum PatientToleratedEnum {
  Well = 1,
  Fairly = 2,
  Poorly = 3,
  Other = 99
}

export const PatientToleratedOptions = [
{ id: 1, label: 'Well' },
{ id: 2, label: 'Fairly' },
{ id: 3, label: 'Poorly' },
{ id: 99, label: 'Other' }
];
